import React, { Component } from "react";
import { connect } from "react-redux";
import { FormGroup, ControlLabel, Checkbox } from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import _ from "lodash";
import "./index.css";

class SeverityCheckBox extends Component {
  constructor(props) {
    super(props);
    let defaultValue = [];
    if(Array.isArray(this.props.defaultValue)){
      defaultValue = this.props.defaultValue;
    } else if(this.props.defaultValue) {
      defaultValue.push(this.props.defaultValue);
    }
    this.state = {
      severityList: [],
      severityCheckedList: defaultValue ? defaultValue : []
    };
  }

  componentDidMount() {
    if (this.props.configList) {
      this.setState({
        severityList: this.props.configList.alert_severities
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.configList !== nextProps.configList && nextProps.configList.alert_severities) {
      this.setState({
        severityList: nextProps.configList.alert_severities
      });
    }
    if (this.props.reset !== nextProps.reset) {
      this.setState({
        severityCheckedList: []
      });
      this.props.change("");
    }
  }

  createCheckbox = (item, index) => {
    return (
      <Checkbox name="severity" key={index} value={item.name} onChange={this.onClick}
        className="styled-checkbox" checked={this.checkChecked(item.name)}
      >
        <FontAwesome className={"icon-tab fa-xs severity-" + item.name} name="circle" /> {item.display_name}
        <span className="checkmark"></span>
      </Checkbox>
    );
  };

  checkChecked = (val) => {
    let checked = false;
    this.state.severityCheckedList.forEach(key => {
      if (key === val) {
        checked = true;
      }
    });
    return checked;
  }

  onClick = e => {
    const { severityCheckedList } = this.state;
    const val = e.target.value;
    //add the checked disciplines to the list
    if (e.target.checked) {
      this.setState({
        severityCheckedList: [...severityCheckedList, ...[val]]
      }, () => {
        this.props.change(this.state.severityCheckedList);
      });
    } else {
      //delete the checked disciplines from the list
      this.setState({
        severityCheckedList: severityCheckedList.filter(tmp => tmp !== val)
      }, () => {
        this.props.change(this.state.severityCheckedList);
      });
    }
  };

  renderSeverityList = () => {
    if (this.state.severityList.length < 1) {
      return null;
    }
    const severityCheckboxList = [];
    _.each(this.state.severityList, item => {
      severityCheckboxList.push(this.createCheckbox(item, this.state.severityList.indexOf(item)));
    });

    return severityCheckboxList;
  };

  render = () => {
    return (
      <div className="severity">
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>Severity</ControlLabel>
          {this.renderSeverityList()}
        </FormGroup>
      </div>
    );
  };
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  const { configList } = state.configuration;
  return {
    user,
    configList
  };
}

export default connect(mapStateToProps)(SeverityCheckBox);



// WEBPACK FOOTER //
// ./src/_components/SeverityCheckBox/index.js